module.exports = __webpack_public_path__ + "img/store.620c75d1.svg";